import React from "react";
import { Link } from "react-router-dom";
import "../components/ErrorPages.css";

const BadRequest = () => {
  return (
    <div className="notfound-body center-section text-center">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
        {/* Left Content */}
        <div className="content">
          <h1>400</h1>
          <h2>Bad Request</h2>
          <p>
            Some required fields are missing or contain incorrect values.
          </p>

          <div className="buttons">
            <Link to="/" className="btn btn-primary me-3">Go to Home</Link>
            <Link to="/contact" className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </div>

        {/* Right Illustration */}
      <div className="col-md-6">
        <div className="illustration">
          {/* You can replace this with SVG component also */}
          <img className="responsive-img"
            src="/graphics/images/400illustration.svg"
            alt="CodeInputs 404 Illustration"
          />
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default BadRequest;
